import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../api/dbService';

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    username: '', email: '', password: '', password2: '',
    ad_soyad: '', telefon: '', firma: '', adres: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  function handleChange(e) {
    setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (form.password !== form.password2) {
      return setError('Parolalar eşleşmiyor');
    }
    if (form.password.length < 6) {
      return setError('Parola en az 6 karakter olmalı');
    }
    setLoading(true);
    try {
      await authService.register(form);
      navigate('/login');
    } catch (err) {
      setError(err.response?.data?.message || 'Kayıt sırasında hata oluştu');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page py-4">
      <div className="login-card" style={{ maxWidth: 500 }}>
        <div className="text-center mb-4">
          <h2 className="fw-bold mb-0">
            <span style={{ color: 'var(--brand-color)' }}>Termo</span>Track
          </h2>
          <small className="text-muted">Yeni Hesap Oluştur</small>
        </div>

        {error && (
          <div className="alert alert-danger py-2">{error}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="row g-3">
            <div className="col-6">
              <label className="form-label small fw-semibold">Kullanıcı Adı *</label>
              <input name="username" className="form-control" value={form.username} onChange={handleChange} required />
            </div>
            <div className="col-6">
              <label className="form-label small fw-semibold" style={{ textTransform: 'none' }}>Email *</label>
              <input name="email" type="email" className="form-control" value={form.email} onChange={handleChange} required />
            </div>
            <div className="col-6">
              <label className="form-label small fw-semibold">Parola *</label>
              <input name="password" type="password" className="form-control" value={form.password} onChange={handleChange} required />
            </div>
            <div className="col-6">
              <label className="form-label small fw-semibold">Parola Tekrar *</label>
              <input name="password2" type="password" className="form-control" value={form.password2} onChange={handleChange} required />
            </div>
            <div className="col-6">
              <label className="form-label small fw-semibold">Ad Soyad</label>
              <input name="ad_soyad" className="form-control" value={form.ad_soyad} onChange={handleChange} />
            </div>
            <div className="col-6">
              <label className="form-label small fw-semibold">Telefon</label>
              <input name="telefon" className="form-control" value={form.telefon} onChange={handleChange} />
            </div>
            <div className="col-12">
              <label className="form-label small fw-semibold">Firma</label>
              <input name="firma" className="form-control" value={form.firma} onChange={handleChange} />
            </div>
          </div>

          <button type="submit" className="btn btn-brand w-100 mt-4" disabled={loading}>
            {loading ? <><span className="spinner-border spinner-border-sm me-2" />Kaydediliyor...</> : 'Kayıt Ol'}
          </button>
        </form>

        <div className="text-center mt-3">
          <small className="text-muted">
            Hesabınız var mı? <Link to="/login" style={{ color: 'var(--brand-color)' }}>Giriş Yap</Link>
          </small>
        </div>
      </div>
    </div>
  );
}
